/**
 * An account page section we have no data for yet: its heading, then a short
 * note in its place (a dash, or a sentence saying why). Keeps the section's
 * place on the page.
 */

import { Gap } from "../../shared/Gap";

export function EmptySection({ title, note }: { title: string; note: string }) {
  return (
    <section className="mt-12">
      <h2 className="m-0 mb-3 text-si-xl font-semibold leading-[1.2] tracking-[-0.015em]">
        {title}
      </h2>
      <Gap title={note} />
    </section>
  );
}
